import { render, staticRenderFns } from "./LogoField.vue?vue&type=template&id=48a3429c&scoped=true"
import script from "./LogoField.vue?vue&type=script&lang=js"
export * from "./LogoField.vue?vue&type=script&lang=js"
import style0 from "./LogoField.vue?vue&type=style&index=0&id=48a3429c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3429c",
  null
  
)

export default component.exports